<template>
  <t-layout :showNav="false">
    <div class="detail-page">
      <div v-if="couponInfo" class="coupon-wrapper">
        <div>
          <div class="page-head">
            <div class="info">{{ couponInfo.is_expired == 1 ? '已过期' : '已领取' }}</div>
          </div>

          <div
            v-if="!!couponInfo && couponInfo.type == 6 && couponInfo.is_used == 1 && !!orderInfo"
          >
            <!-- <div class="lotto-wrap">
              <div class="list-cells">
                <div class="cell">
                  <div class="cell__bd">福彩类型</div>
                  <div class="cell__ft">{{ orderInfo.name }}</div>
                </div>
                <div class="cell">
                  <div class="cell__bd">开奖期数</div>
                  <div class="cell__ft">第{{ orderInfo.issue }}期</div>
                </div>

                <div class="cell" :class="orderInfo.status == 1 ? 'cell-act' : ''">
                  <div class="cell__bd">中奖状态</div>
                  <div class="cell__ft">
                    <div @click="tapLotteryAddress('query')" class="entry">
                      <div>{{ orderInfo.status == 1 ? orderInfo.desc : '查看开奖' }}</div>
                      <img
                        src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/icon-right.png"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="orderInfo.status == 1">
                  <div class="cell" :class="orderInfo.status == 1 ? 'cell-act' : ''">
                    <div class="cell__bd">中奖金额</div>
                    <div class="cell__ft fontBlod">{{ orderInfo.amount }}元</div>
                  </div>
                </div>
              </div>
            </div> -->

            <div class="lottery-wrap">
              <!-- <div class="lottery-head">
                <img
                  src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/lottery-panel-icon.png"
                />
                <div class="lottery-cont">
                  <div class="title">{{ orderInfo.name }}</div>
                  <div class="subtitle">第{{ orderInfo.issue }}期</div>
                </div>
              </div> -->
              <div class="lottery-info">
                <div class="lottery-item">
                  <div class="lottery-value" :style="orderInfo.status == 2 ? 'color: #8C8C8C' : ''">
                    {{ orderInfo.status_name }}
                  </div>
                  <div class="lottery-label">中奖状态</div>
                </div>
                <div class="lottery-item">
                  <div class="lottery-value">
                    {{
                      orderInfo.status == 1
                        ? orderInfo.amount + '元'
                        : orderInfo.status == 2
                        ? '0元'
                        : '--'
                    }}
                  </div>
                  <div class="lottery-label">中奖金额</div>
                </div>
              </div>
            </div>

            <div class="order-wrap lottery-info-wrap">
              <div class="list-cells">
                <div class="cell">
                  <div class="cell__bd">福袋类型</div>
                  <div class="cell__ft">
                    {{ orderInfo.name }}
                  </div>
                </div>
                <div class="cell">
                  <div class="cell__bd">开奖期数</div>
                  <div class="cell__ft">第{{ orderInfo.issue }}期</div>
                </div>
                <div class="cell" v-if="orderInfo.status == 1">
                  <div class="cell__bd">中奖信息</div>
                  <div class="cell__ft">{{ orderInfo.desc }}</div>
                </div>
              </div>
            </div>

            <div class="number-wrap">
              <div class="list-cells">
                <div class="cell">
                  <div class="cell__bd">开奖号码</div>
                  <div class="cell__ft">
                    <div class="nums">
                      <div
                        class="dot"
                        :class="orderInfo.lottery == 1 ? 'act' : ''"
                        v-for="(item, index) in orderInfo.announcement_stakes"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="cell">
                  <div class="cell__bd">领取号码</div>
                  <div class="cell__ft">
                    <div class="nums">
                      <div
                        class="dot"
                        :class="orderInfo.lottery == 1 ? 'act' : ''"
                        v-for="(item, index) in orderInfo.stakes"
                        :key="index"
                      >
                        {{ item }}
                      </div>
                    </div>
                    <div v-if="orderInfo.stakes" class="tip">1注{{ orderInfo.times }}倍</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="order-wrap">
            <div class="list-cells">
              <div class="cell">
                <div class="cell__bd">订单编号</div>
                <div class="cell__ft cell_copy" @click="doCopy(couponInfo.p_order_no)">
                  {{ couponInfo.p_order_no }}
                </div>
              </div>
              <div v-if="orderInfo.print_no" class="cell">
                <div class="cell__bd">电子凭证</div>
                <div class="cell__ft">{{ orderInfo.print_no }}</div>
              </div>
              <div v-if="orderInfo" class="cell">
                <div class="cell__bd">领券时间</div>
                <div class="cell__ft">{{ orderInfo.user_coupon_created_time }}</div>
              </div>
              <div v-if="orderInfo" class="cell">
                <div class="cell__bd">领号时间</div>
                <div class="cell__ft">{{ orderInfo.create_time }}</div>
              </div>
            </div>
          </div>

          <div v-if="couponInfo.description" class="remark">
            <div v-html="couponInfo.description"></div>
          </div>

          <div v-if="orderInfo && orderInfo.status == 1" class="bottom-wrap">
            <!-- <div class="btn" @click="tapLotteryAddress('query')">查看详情</div> -->
            <!-- <div class="btn act" @click="haddleToRecive()">去领奖</div> -->
            <div class="btn act" @click="tapLotteryAddress('query')">去委托领奖</div>
          </div>
        </div>
      </div>

      <van-popup v-model="showCodeToast" overlay-class="cus-overlay">
        <div class="inner" @click.stop="() => {}">
          <div class="title">你的号码</div>
          <div class="nums-wrap" v-if="!!orderInfo">
            <div class="nums">
              <div
                class="dot"
                :class="orderInfo.lottery == 1 ? 'act' : ''"
                v-for="(item, index) in orderInfo.stakes"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="tips">请关注开奖时间</div>
          <div class="btn" @click="closeCodeToast">我知道了</div>
        </div>
      </van-popup>

      <!-- <div
        v-if="!!showCodeToast"
        class="lottery-popup"
        :class="!!showCodeToast ? 'mask-show' : 'mask-hide'"
        @click="closeCodeToast"
      >
        <div class="inner" @click.stop="() => {}">
          <div class="title">你的号码</div>
          <div class="nums-wrap">
            <div class="nums">
              <div
                class="dot"
                :class="orderInfo.lottery == 1 ? 'act' : ''"
                v-for="(item, index) in orderInfo.stakes"
                :key="index"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div class="tips">请关注开奖时间</div>
          <div class="btn" @click="closeCodeToast">我知道了</div>
        </div>
      </div> -->
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'lotteryDetailView',
  components: {},
  data() {
    return {
      couponInfo: null,
      shopList: null,
      orderInfo: null,
      descImages: [],
      needShowToast: 0,
      showCodeToast: false
    }
  },
  created() {},
  activated() {
    this.showCodeToast = false
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '领取详情')
    const options = this.$route.query
    this.from = options.from
    // this.needShowToast = options.needShowToast
    this.id = parseInt(options.id)
    if (this.from) this.user_coupon_id = parseInt(options.user_coupon_id)

    this.getCouponInfo()
  },
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    if (from.name == 'issueTicketView') {
      next(vm => {
        vm.needShowToast = 1
      })
    } else {
      next()
    }
  },
  methods: {
    async getCouponInfo() {
      let data = { id: this.id }
      let res = null
      if (this.from == 'user') {
        data = { id: this.user_coupon_id }
        res = await this.$api.coupon.getUserCouponInfo(data)
      } else {
        res = await this.$api.coupon.getShopCouponInfo(data)
      }

      let result = res.data

      if (result.code == 0) {
        let couponInfo = result.data.coupon_info
        couponInfo.description = this.formatRichText(couponInfo.description)

        let descImages = []
        if (couponInfo.description) {
          couponInfo.description.replace(
            /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
            function (match, capture) {
              descImages.push(capture)
            }
          )
        }

        this.couponInfo = couponInfo
        this.descImages = descImages
        this.shopList = result.data.shop_list

        this.getOrderInfo()
      }
    },

    getOrderInfo() {
      if (!this.couponInfo.order_no) {
        this.needShowToast = 0
        return
      }
      this.$api.coupon.lotteryOrderInfo({ order_no: this.couponInfo.order_no }).then(result => {
        let res = result.data
        // res.data.lottery = 2
        // res.data.status = 1
        // res.data.desc = '六等奖'
        // res.data.amount = '5元'
        if (res.code == 0) {
          this.orderInfo = res.data

          if (!!this.needShowToast) {
            this.showCodeToast = true
            this.needShowToast = 0
          }
        }
      })
    },

    async tapLotteryAddress(type) {
      let result = await this.$api.user.getUserInfo()
      let data = result.data
      if (data.code == 0) {
        let userInfo = data.data.user_info
        if (userInfo.mobile) {
          this.getLotteryAddress(type)
        } else {
          this.$eventBus.$emit('haddleLogin')
        }
      }
    },

    getLotteryAddress(type) {
      let { user_coupon_id } = this.couponInfo
      this.$api.coupon.getLotteryAddress({ type, user_coupon_id }).then(result => {
        let res = result.data
        if (res.code == 0) {
          const { url } = res.data

          window.location.href = url
        }
      })
    },

    haddleToRecive() {
      this.$router.push({
        path: `/lottery/receive?user_coupon_id=${this.couponInfo.user_coupon_id}`
      })
    },

    doCopy(val) {
      this.$copyText(val).then(
        e => {
          console.log('e', e)
          this.$toast({
            duration: 2000,
            message: '复制成功'
          })
        },
        err => {
          console.log('err', err)
          this.$toast({
            duration: 2000,
            message: '复制失败'
          })
        }
      )
    },

    closeCodeToast() {
      this.showCodeToast = false
    },

    formatRichText(html) {
      return html.replace(/\<img/gi, '<img style="max-width:100%;height:auto;"')
    }
  }
}
</script>
<style lang="less">
.panel {
  position: relative;
  width: 100%;
  margin-bottom: 24rpx;
  background: var(--panel-background);
  border-radius: var(--panel-radius);
  overflow: hidden;
}

.panel__hd {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32rpx 20rpx 16rpx;
}

.panel__hd .title {
  display: inline-block;
  line-height: 42rpx;
  color: #3d3d3d;
  font-size: 36rpx;
  font-weight: 600;
  max-width: 480rpx;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.panel__bd {
  padding: 0 20rpx 20rpx;
}

/* End panel */

/* Begin list-cells */
.list-cells {
  padding: 20rpx 32rpx;
}

.list-cells .cell {
  position: relative;
  display: flex;
  align-items: center;
  padding: 24rpx 0;
  font-size: 26rpx;
}

.list-cells .cell:not(:last-child)::after {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: 2rpx solid var(--bottom-line-color);
}

.list-cells .cell .cell__bd {
  margin-right: 100rpx;
}
.list-cells .cell .cell__ft {
  flex: 1;
}

.cus-overlay {
  background-color: rgba(0, 0, 0, 0.8);
}

.detail-page {
  .van-popup {
    background-color: transparent;
  }
}
</style>
<style lang="less" scoped>
.detail-page {
  padding-bottom: 200rpx;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.page-head {
  width: 100%;
  height: 330rpx;
  background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/detail-bg-v3.png)
    no-repeat top center;
  background-size: 100% 100%;

  .info {
    line-height: 30rpx;
    padding-top: 56rpx;
    padding-left: 34rpx;
    font-size: 30rpx;
    color: #353738;
    font-weight: 500;
  }
}

.remark {
  margin-left: 20rpx;
  margin-right: 20rpx;
  padding: 24rpx 32rpx;
  background: #fff;
}

.lotto-wrap,
.lottery-wrap,
.order-wrap {
  background: #fff;
  margin-left: 20rpx;
  margin-right: 20rpx;
  margin-bottom: 20rpx;

  .list-cells {
    padding: 16rpx 32rpx;

    .cell {
      font-size: 26rpx;
      line-height: 26rpx;
      &::after {
        border: 0;
      }
    }
  }

  .entry {
    display: flex;
    align-items: center;
    color: #a1a7ad;
    font-size: 26rpx;
    position: relative;

    img {
      position: absolute;
      right: 0;
      top: 0;
      display: block;
      width: 32rpx;
      height: 32rpx;
      margin-left: 6rpx;
    }
  }
}

.lottery-wrap {
  margin-top: -180rpx;
  padding: 0 32rpx 0;

  background: linear-gradient(180deg, #ffffff30 0%, #fff 75.48%);

  .lottery-head {
    display: flex;
    align-items: center;
    padding-bottom: 32rpx;
    border-bottom: 2rpx solid #f5f5f5;

    > img {
      display: block;
      width: 96rpx;
      height: 96rpx;
      margin-right: 24rpx;
    }

    .lottery-cont {
      flex: 1;
      font-size: 26rpx;
      line-height: 26rpx;
      color: #a1a7ad;

      .title {
        font-weight: 500;
        color: #353738;
        margin-bottom: 12rpx;
        font-size: 30rpx;
        line-height: 30rpx;
      }
    }
  }

  .lottery-info {
    display: flex;
    align-items: center;
    height: 180rpx;

    .lottery-item {
      width: 50%;
      text-align: center;
      font-size: 26rpx;
      line-height: 26rpx;
      color: #353738;

      .lottery-value {
        font-size: 36rpx;
        line-height: 40rpx;
        font-weight: 500;
        color: #ff5566;
        margin-bottom: 24rpx;
      }

      &:nth-child(1) {
        position: relative;

        &::after {
          content: '';
          height: 80rpx;
          width: 2rpx;
          background: #f5f5f5;
          position: absolute;
          right: 0;
          top: 4rpx;
        }
      }
    }
  }
}

.order-wrap {
  .list-cells {
    .cell {
      color: #8c8c8c;
      .cell__bd {
        line-height: 32rpx;
      }
      .cell__ft {
        text-align: right;
        line-height: 32rpx;

        &.cell_copy {
          padding-right: 44rpx;
          background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/copy-icon.png');
          background-position: right center;
          background-size: 32rpx 32rpx;
          background-repeat: no-repeat;
        }
      }
    }
  }
}

.lottery-info-wrap {
  .list-cells {
    .cell {
      color: #353738;

      .cell__ft {
        text-align: left;
      }
    }
  }
}

.cell-act {
  .cell__ft {
    .entry {
      color: #ff5566;
    }
    color: #ff5566;
  }
}

.nums {
  display: flex;

  .dot {
    display: block;
    width: 60rpx;
    height: 60rpx;
    border-radius: 30rpx;
    margin-right: 16rpx;
    background: linear-gradient(325deg, #f93434 20.42%, #ff7759 88.58%);
    color: #fff;
    font-size: 30rpx;
    line-height: 60rpx;
    text-align: center;
    font-weight: 500;

    &:last-child {
      margin-right: 0;
    }

    &.act {
      background: linear-gradient(325deg, #f93434 20.42%, #ff7759 88.58%);

      &:last-child {
        background: linear-gradient(157deg, #3dc5ff 6.74%, #027bdb 89.58%);
      }
    }
  }
}

.number-wrap {
  background: #fff;
  margin-left: 20rpx;
  margin-right: 20rpx;
  margin-bottom: 20rpx;

  .cell {
    display: block;

    .cell__bd {
      margin-bottom: 24rpx;
    }

    .cell__ft {
      position: relative;
    }
  }

  .tip {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 26rpx;
    line-height: 60rpx;
  }
}

.bottom-wrap {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 18rpx 32rpx 76rpx;
  background: #fff;
  box-shadow: 0 -10px 20px 0 #3537380a;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .btn {
    width: 176rpx;
    height: 72rpx;
    border-radius: 4rpx;
    border: 2rpx solid #5e656b;
    background: #fff;
    color: #5e656b;
    font-size: 28rpx;
    line-height: 72rpx;
    text-align: center;
    font-weight: 500;

    &.act {
      color: #fff;
      background: #ff5566;
      border: 2rpx solid #ff5566;
    }
  }
}

.fontBlod {
  font-weight: 600;
}

// .lottery-popup {
//   width: 100%;
//   height: 100%;
//   position: fixed;
//   left: 0;
//   top: 0;
//   z-index: 9;
//   background: rgba(0, 0, 0, 0.95);
//   opacity: 0;
//   transition: opacity 3s;

.inner {
  width: 528rpx;
  height: 504rpx;
  // position: fixed;
  // left: 50%;
  // top: 50%;
  // transform: translate(-50%, -50%);
  background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/lottery-alert-bg.png)
    no-repeat top center;
  background-size: 100% 100%;
  padding: 48rpx 40rpx 0;
  border-radius: 4rpx;
  overflow: hidden;

  .title {
    text-align: center;
    color: #353738;
    font-size: 40rpx;
    line-height: 40rpx;
    margin-bottom: 48rpx;
    font-weight: 500;
  }

  .nums-wrap {
    width: 100%;
    height: 134rpx;
    background: url(https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/number-bg.png) no-repeat
      top center;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24rpx;

    .nums {
      .dot {
        width: 48rpx;
        height: 48rpx;
        line-height: 48rpx;
        font-size: 26rpx;
        margin-right: 8rpx;
      }
    }
  }

  .tips {
    text-align: center;
    font-size: 30rpx;
    line-height: 30rpx;
    color: #8c8c8c;
    margin-bottom: 60rpx;
  }

  .btn {
    width: 368rpx;
    height: 72rpx;
    border-radius: 36rpx;
    background: #f56;
    margin: 0 auto;
    text-align: center;
    line-height: 72rpx;
    font-size: 28rpx;
    font-weight: 500;
    color: #fff;
  }
}
// }
</style>
